<template>
  <div
    class="fixed bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center"
  >
    <!--
      Background overlay, show/hide based on modal state.
  
      Entering: "ease-out duration-300"
        From: "opacity-0"
        To: "opacity-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100"
        To: "opacity-0"
    -->
    <div class="fixed inset-0 transition-opacity">
      <div class="absolute inset-0 bg-gray-500 opacity-75" @click="close"></div>
    </div>

    <!--
      Modal panel, show/hide based on modal state.
  
      Entering: "ease-out duration-300"
        From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        To: "opacity-100 translate-y-0 sm:scale-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100 translate-y-0 sm:scale-100"
        To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    -->
    <div
      class="relative bg-white rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full sm:p-6"
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-headline"
    >
      <div class="sm:flex sm:items-start">
        <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
          <h3
            class="text-lg leading-6 font-medium text-gray-900"
            id="modal-headline"
          >
            Own Number Approval
          </h3>
          <div class="mt-2"></div>
        </div>
      </div>
      <div class="sm:ml-4 mt-4">
        <Alert
          v-if="pendingApproval && pendingApproval.phoneNumber"
          :type="'warning'"
          :text="
            'We have received your details. We will contact you over email/whatsapp  for Whatsapp API approval'
          "
        ></Alert>
        <div>
          <label
            for="email"
            class="block text-sm font-medium leading-5 text-gray-700"
          >
            Phone Number (Should not have a whatsapp account)
          </label>
          <div class="mt-1 relative rounded-md shadow-sm">
            <input
              class="bg-white focus:outline-none focus:shadow-outline border border-gray-300 rounded-md py-2 px-4 block w-full appearance-none leading-normal"
              type="text"
              ref="phoneNumber"
              v-model="form.phoneNumber"
              placeholder="Phone Number"
            />
            <p class="mt-2 text-gray-600">
              When you visit this link
              <a
                class="text-blue-700 cursor-pointer"
                :href="`https://wa.me/${form.phoneNumber}`"
                target="_blank"
                >https://wa.me/{{ form.phoneNumber }}</a
              >
              it should say invalid number not load any WhatsApp profile.
            </p>
          </div>
        </div>
        <div class="mt-4">
          <label
            for="email"
            class="block text-sm font-medium leading-5 text-gray-700"
          >
            Contact Email
          </label>
          <div class="mt-1 relative rounded-md shadow-sm">
            <input
              class="bg-white focus:outline-none focus:shadow-outline border border-gray-300 rounded-md py-2 px-4 block w-full appearance-none leading-normal"
              type="text"
              v-model="form.contactEmail"
              placeholder="youremail@domain.com"
            />
          </div>
        </div>
        <div class="mt-4">
          <label
            for="email"
            class="block text-sm font-medium leading-5 text-gray-700"
          >
            Contact Phone Number
          </label>
          <div class="mt-1 relative rounded-md shadow-sm">
            <input
              class="bg-white focus:outline-none focus:shadow-outline border border-gray-300 rounded-md py-2 px-4 block w-full appearance-none leading-normal"
              type="text"
              v-model="form.contactPhoneNumber"
              placeholder="Phone number to contact you"
            />
          </div>
        </div>
        <fieldset class="mt-4">
          <legend class="sr-only">Notifications</legend>
          <div class="space-y-5">
            <div class="relative flex items-start">
              <div class="flex h-6 items-center">
                <input
                  id="number_not_connected_whatsapp"
                  v-model="form.isNumberNotConnectedToWhatsapp"
                  aria-describedby="number_not_connected_whatsapp-description"
                  name="number_not_connected_whatsapp"
                  type="checkbox"
                  class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                />
              </div>
              <div class="ml-3 text-sm leading-6">
                <label
                  for="number_not_connected_whatsapp"
                  class="font-medium text-gray-900"
                  >The provided number is not connected to any whatsapp
                  app</label
                >
              </div>
            </div>
            <div class="relative flex items-start">
              <div class="flex h-6 items-center">
                <input
                  id="fb_business_manager_checkbox"
                  v-model="form.hasFacebookBusinessManager"
                  aria-describedby="fb_business_manager_checkbox-description"
                  name="fb_business_manager_checkbox"
                  type="checkbox"
                  class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                />
              </div>
              <div class="ml-3 text-sm leading-6">
                <label
                  for="fb_business_manager_checkbox"
                  class="font-medium text-gray-900"
                  >I have Facebook business manager and its verified by
                  facebook</label
                >
              </div>
            </div>
          </div>
        </fieldset>
      </div>
      <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
        <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
          <button
            :disabled="
              $v.form.$invalid ||
                (pendingApproval && pendingApproval.phoneNumber)
            "
            class="Polaris-Button Polaris-Button--primary disabled:opacity-50"
            type="button"
            @click="onCreate"
          >
            <span class="Polaris-Button__Content">
              <span class="Polaris-Button__Text">Submit for approval</span>
            </span>
          </button>
        </span>
        <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
          <button
            type="button"
            class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5"
            @click="close"
          >
            Cancel
          </button>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";

import Alert from "../Common/Alert.vue";

export default {
  components: {
    Alert
  },
  props: {},
  data() {
    return {
      form: {
        phoneNumber: "",
        contactPhoneNumber: "",
        contactEmail: "",
        isNumberNotConnectedToWhatsapp: false,
        hasFacebookBusinessManager: false
      },
      pendingApproval: {}
    };
  },
  validations: {
    form: {
      phoneNumber: {
        required
      },
      contactPhoneNumber: {
        required
      },
      contactEmail: {
        required,
        email
      },
      isNumberNotConnectedToWhatsapp: {
        checked: value => value === true
      },
      hasFacebookBusinessManager: {
        checked: value => value === true
      }
    }
  },
  mounted() {
    this.$refs.phoneNumber.focus();
    this.getPendingOwnNumber();
  },
  methods: {
    close() {
      this.$emit("close");
    },
    onCreate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.$store
        .dispatch("addOwnNumberForApproval", {
          requestParams: this.form
        })
        .then(response => {
          this.pendingApproval = response.ownNumberApproval;
          this.sendToCrisp();
          this.close();
        });
    },
    getPendingOwnNumber() {
      this.$store.dispatch("getPendingOwnNumberApproval").then(response => {
        if (response.pendingApproval) {
          this.pendingApproval = response.pendingApproval;
          this.form = this.pendingApproval;
        }
      });
    },
    sendToCrisp() {
      // $crisp.push(["do", "chat:open"]); // eslint-disable-line
      // eslint-disable-next-line
      $crisp.push([
        "do",
        "message:send",
        [
          "text",
          `Custom Number Approval : \n\n phone number: ${this.form.phoneNumber}\n\n contact email : ${this.form.contactEmail} \n\n contact phone number: ${this.form.contactPhoneNumber}`
        ]
      ]);
    }
  }
};
</script>

<style lang="scss" scoped></style>
